CDN.requireOnce([
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.Control_Collection, },
    { code: CDN.PackageCode.Control_Login, },
    { code: CDN.PackageCode.Control_UI_Input, },
    { code: CDN.PackageCode.API_AutoComplete_v1, },    
], () => {
    $(document).ready(Pages.Test._Controls.Permission.__cdn_pages_test_controls_collectionmanager_onDocumentReadyAsync);
});

namespace Pages.Test._Controls.Permission {
    export async function __cdn_pages_test_controls_collectionmanager_onDocumentReadyAsync() {
        let main = document.querySelector('main');

        let login = new CDN.Controls.Login(main, {
            onLogin: (result) => {
                login.hide();

                let collectionDiv = document.createElement('div');
                collectionDiv.style.display = 'flex';
                collectionDiv.style.flexDirection = 'row';

                let collectionManager = new CDN.Controls.Collection.CollectionManager(collectionDiv, {
                    userToken: result.UserToken,
                    collectionType: CDN.API.Collection.v1.CollectionType.ClientVehicle,
                    onSelectAsync: (collection, cancellationToken) => {
                        collectionItemManager.setCollectionAsync(collection, cancellationToken);
                    },
                });
                collectionManager.container.style.flexShrink = "0";
                collectionManager.container.style.maxHeight = '600px';

                let collectionItemManager = CDN.Controls.Collection.Vehicle.CreateClientVehicleCollectionManager(collectionDiv, result.UserToken);

                main.appendChild(collectionDiv);
            }
        });

    }
}
